import React from "react";

import { Form } from "react-bootstrap";

export default (props: any) => <Form.Control as="textarea" {...props} />;
